import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n';
import 'antd/dist/reset.css';
import { BrowserRouter } from 'react-router-dom';

console.log("🔥 React app is starting...");
ReactDOM.createRoot(document.getElementById('root')).render(
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
  

reportWebVitals();
